import {gsap, ScrollTrigger} from "../LibrariesImport";

export default class BannerHome {
    static init() {
        const banner = document.querySelector(".banner-home");

        if (!banner || ScrollTrigger.isTouch === 1) {
            return;
        }

        const bigA = banner.querySelector(".big-a img");
        // const griffe = banner.querySelector(".banner-bg img");


        let ticking = false;

        // Fonction utilitaire pour limiter une valeur entre -50 et 50
        const clamp = (value) => Math.min(Math.max(value, -50), 50);

        banner.addEventListener("mousemove", (e) => {
            if (!ticking) {
                window.requestAnimationFrame(() => {
                    const rect = banner.getBoundingClientRect();
                    const centerX = rect.width / 2;
                    const centerY = rect.height / 2;

                    // Calculer la distance par rapport au centre
                    const deltaX = e.clientX - (rect.left + centerX);
                    const deltaY = e.clientY - (rect.top + centerY);

                    const bigAMoveX = clamp(deltaX * 0.04);
                    const bigAMoveY = clamp(deltaY * 0.04);

                    // const griffeMoveX = clamp(deltaX * -0.04);
                    // const griffeMoveY = clamp(deltaY * -0.04);

                    gsap.to(bigA, {
                        x: bigAMoveX,
                        y: bigAMoveY,
                        duration: 1,
                        overwrite: true,
                    });

                    // gsap.to(griffe, {
                    //     x: griffeMoveX,
                    //     y: griffeMoveY,
                    //     duration: 1,
                    //     overwrite: true,
                    // });

                    ticking = false;
                });

                ticking = true;
            }
        }, { passive: true });
    }
}